<qr-code *ngIf="qrCodeUrl" [value]="qrCodeUrl" [size]="256" [level]="'M'"></qr-code>
<br />
<br />

{{ qrCodeUrl }}
